var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.tweet
      ? _c(
          "div",
          [
            _c("h2", { staticClass: "mt-5" }, [_vm._v("Replies")]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "form-inline rounded border m-1 p-1",
                attrs: { id: "replySortForm", action: "/", method: "get" }
              },
              [
                _c("div", { staticClass: "form-group mr-2 ml-1 mt-1 mb-1" }, [
                  _c(
                    "label",
                    {
                      staticClass: "font-weight-bold mr-1",
                      attrs: { for: "reply_sort" }
                    },
                    [_vm._v("Sort from ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      staticClass: "form-control",
                      attrs: { type: "", id: "reply_sort" },
                      on: {
                        input: function($event) {
                          return _vm.repliesSortSelectHandler($event)
                        }
                      }
                    },
                    _vm._l(_vm.replySortOptions, function(sortValue, sortKey) {
                      return _c("option", { domProps: { value: sortKey } }, [
                        _vm._v(_vm._s(sortValue))
                      ])
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group m-1" }, [
                  _c(
                    "label",
                    {
                      staticClass: "font-weight-bold mr-1",
                      attrs: { for: "reply_group_stance" }
                    },
                    [_vm._v("Show stance ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      staticClass: "form-control",
                      attrs: { type: "", id: "reply_group_stance" },
                      on: {
                        input: function($event) {
                          return _vm.repliesShowSelectHandler($event)
                        }
                      }
                    },
                    _vm._l(_vm.replyShowStanceOptions, function(
                      showValue,
                      showKey
                    ) {
                      return _c(
                        "option",
                        {
                          staticStyle: { "text-transform": "capitalize" },
                          domProps: { value: showKey }
                        },
                        [_vm._v(_vm._s(showValue))]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group m-1" }, [
                  _c(
                    "label",
                    {
                      staticClass: "font-weight-bold mr-1",
                      attrs: { for: "filter_verified" }
                    },
                    [_vm._v("Accounts to show")]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      staticClass: "form-control",
                      attrs: { type: "", id: "filter_verified" },
                      on: {
                        input: function($event) {
                          return _vm.repliesAccountShowSelectHandler($event)
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        {
                          staticStyle: { "text-transform": "capitalize" },
                          attrs: { value: "all" }
                        },
                        [_vm._v("All accounts")]
                      ),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          staticStyle: { "text-transform": "capitalize" },
                          attrs: { value: "verified" }
                        },
                        [_vm._v("Verified Only")]
                      ),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          staticStyle: { "text-transform": "capitalize" },
                          attrs: { value: "unverified" }
                        },
                        [_vm._v("Unverified Only")]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group m-1" }, [
                  _c(
                    "label",
                    {
                      staticClass: "font-weight-bold mr-1",
                      attrs: { for: "replies_per_page" }
                    },
                    [_vm._v("Replies to show ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.repliesPerPage,
                          expression: "repliesPerPage"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "", id: "replies_per_page" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.repliesPerPage = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.repliesPerPageOptions, function(showValue) {
                      return _c("option", { domProps: { value: showValue } }, [
                        _vm._v(_vm._s(showValue))
                      ])
                    }),
                    0
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.replies && _vm.replies.length > 0
              ? [
                  _c(
                    "transition-group",
                    { attrs: { name: "fade", tag: "div" } },
                    _vm._l(_vm.paginatedReplies, function(reply) {
                      return _c("tweet-reply", {
                        key: reply.id_str,
                        attrs: { reply: reply }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("paginate", {
                    staticStyle: { "justify-content": "center" },
                    attrs: {
                      "page-count": _vm.getPageCount,
                      "page-range": 5,
                      "margin-pages": 1,
                      "click-handler": _vm.clickCallback,
                      "prev-text": "<",
                      "next-text": ">",
                      "container-class": "pagination",
                      "first-last-button": true,
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "break-view-class": "break-view",
                      "break-view-link-class": "break-view-link"
                    },
                    model: {
                      value: _vm.currentRepliesPage,
                      callback: function($$v) {
                        _vm.currentRepliesPage = $$v
                      },
                      expression: "currentRepliesPage"
                    }
                  })
                ]
              : _vm.fetchingReplies
              ? _c("div", { staticClass: "m-3 text-center" }, [
                  _c("p", { staticClass: "font-weight-bold" }, [
                    _c("span", {
                      staticClass: "spinner-grow spinner-grow-sm mr-2",
                      attrs: { role: "status", "aria-hidden": "true" }
                    }),
                    _vm._v(
                      "\n                Fetching replies ...\n            "
                    )
                  ])
                ])
              : _c("p", { staticClass: "m-3" }, [_vm._v("No replies")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: {
                  id: "stanceHelpModal",
                  tabindex: "-1",
                  role: "dialog",
                  "aria-labelledby": "exampleModalLabel",
                  "aria-hidden": "true"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-dialog", attrs: { role: "document" } },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _c(
                          "h5",
                          {
                            staticClass: "modal-title",
                            attrs: { id: "exampleModalLabel" }
                          },
                          [_vm._v("Stance Classification")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: {
                              type: "button",
                              "data-dismiss": "modal",
                              "aria-label": "Close"
                            }
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body" }, [
                        _c("p", [
                          _vm._v(
                            "\n                            Each reply to a tweet has a stance, an opinion the reply has towards the original tweet.\n                            This service classes stance into four categories, Support (Green), Deny (Red), Comment\n                            (Blue), and Question (Yellow).\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                            Automatically categorised stance is shown on the bottom left and its corresponding\n                            colour is used as the tweet's background. Darker background colour indicates more\n                            confidence in the classification.\n                        "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button", "data-dismiss": "modal" }
                          },
                          [_vm._v("Close")]
                        )
                      ])
                    ])
                  ]
                )
              ]
            )
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }